"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreDataDictionaryViewsWatchers = exports.coreDataDictionaryViewsReducers = void 0;
const add_1 = require("./add.js");
const redux_1 = require("redux");
const delete_1 = require("./delete.js");
const get_1 = require("./get.js");
const patch_1 = require("./patch.js");
const post_1 = require("./post.js");
const remove_1 = require("./remove.js");
const update_1 = require("./update.js");
const xuder_1 = require("@sonar-software/xuder");
const references_1 = require("./references/index.js");
const shared_key_1 = require("./shared-key/index.js");
exports.coreDataDictionaryViewsReducers = (0, redux_1.combineReducers)({
    delete: delete_1.deleteCoreDataDictionaryViewsAsyncSlice.asyncReducers,
    get: (0, xuder_1.joinCollectionReducers)([
        get_1.getCoreDataDictionaryViewsAsyncSlice.asyncReducers,
        add_1.addCoreDataDictionaryViewsSyncSlice.syncReducer,
        remove_1.removeCoreDataDictionaryViewSyncSlice.syncReducer,
        update_1.updateCoreDataDictionaryViewsSyncSlice.syncReducer
    ], get_1.getCoreDataDictionaryViewsAsyncSlice.asyncState),
    patch: patch_1.patchCoreDataDictionaryViewsAsyncSlice.asyncReducers,
    post: post_1.postCoreDataDictionaryViewAsyncSlice.asyncReducers,
    references: references_1.coreDataDictionaryViewReferencesReducers,
    sharedKey: shared_key_1.coreDataDictionaryViewsSharedKeyReducers
});
exports.coreDataDictionaryViewsWatchers = (0, xuder_1.combineAllWatchers)([
    delete_1.deleteCoreDataDictionaryViewsAsyncSlice.asyncWatchers,
    get_1.getCoreDataDictionaryViewsAsyncSlice.asyncWatchers,
    patch_1.patchCoreDataDictionaryViewsAsyncSlice.asyncWatchers,
    post_1.postCoreDataDictionaryViewAsyncSlice.asyncWatchers,
    references_1.coreDataDictionaryViewReferencesWatchers,
    shared_key_1.coreDataDictionaryViewsSharedKeyWatchers
]);
//# sourceMappingURL=index.js.map